import React, { useState, useEffect } from 'react';
import { Form, Button, Select, InputNumber, Slider, Upload, Input, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import InputRules from '../../../data/InputRules';
import { connect } from 'react-redux';
import { Actions } from '../../../store/actions';
import { toFormData } from '../../../util/FormData';

const years = [2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012];
const bodyTypes = [
	'Sedan',
	'SUVS',
	'Convertibles',
	'Hybrids',
	'Hatchbacks',
	'Pickups',
	'Wagons',
	'Double Cabin',
	'MPV',
	'Station Wagon',
	'Off Road',
];
const features = [
	'Air Bags',
	'Air conditioning',
	'Cruise controls',
	'Heated seats',
	'Power lock',
	'Power mirror',
	'Power steering',
	'Power windows',
	'Rear AC vents',
	'Rear camera',
	'Rear speakers',
	'Steering switches',
	'DVD Player',
	'Media Navigation',
	'Infotainment',
	'Sun Roof',
];
const colors = ['Black', 'White'];
const regCities = ['Lahore', 'Islamabad', 'Karachi'];
const layout = {
	labelCol: {
		span: 8,
	},
	wrapperCol: {
		span: 12,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 8,
		span: 16,
	},
};
const uploadButton = (
	<div>
		<PlusOutlined />
		<div style={{ marginTop: 8 }}>Upload</div>
	</div>
);

const VehicleEditForm = ({
	makes,
	models,
	generations,
	utils,
	fetchMakes,
	fetchModels,
	fetchGenerations,
	fetchVehicleUtils,
	vehicle,
	updateVehicleAd,
	setEditModal,
	setRefresh,
}) => {
	const [selectedMake, setSelectedMake] = useState();
	const [selectedModel, setSelectedModel] = useState();
	const [filteredModels, setFilteredModels] = useState();
	const [filteredGenerations, setFilteredGenerations] = useState();
	const [filelist, setFileList] = useState([]);
	const [imageList, setImageList] = useState([]);

	useEffect(() => {
		fetchMakes();
		fetchModels();
		fetchGenerations();
		fetchVehicleUtils();
	}, []);

	useEffect(() => {
		setFilteredModels(models.filter((item) => item.make === selectedMake));
		setFilteredGenerations(generations.filter((item) => item.model === selectedModel));
	}, [selectedMake, selectedModel]);

	useEffect(() => {
		if (filelist.length) {
			const file = filelist[filelist.length - 1].originFileObj;
			file.thumbUrl = URL.createObjectURL(file);
			const list = imageList;
			list.push(file);
			setImageList(list);
		}
	}, [filelist]);

	const onFinish = (values) => {
		values.user = { _id: vehicle.user._id };
		values.images = imageList;
		const data = toFormData(values);
		updateVehicleAd(vehicle.id, data);
		setRefresh();
		setEditModal();
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	const handleChange = ({ fileList }) => {
		setFileList(fileList);
	};

	return (
		<Form
			{...layout}
			name="vehicleEditForm"
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
		>
			<Form.Item
				label="Make"
				name={['vehicle', 'make']}
				initialValue={vehicle.make}
				rules={InputRules.required('Please select make!')}
			>
				<Select showSearch allowClear={true} placeholder="Select a make" onChange={(value) => setSelectedMake(value)}>
					{makes?.map((make) => (
						<Select.Option value={make._id} key={make._id}>
							{make._id}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Model"
				name={['vehicle', 'model']}
				initialValue={vehicle.model}
				rules={InputRules.required('Please select model!')}
			>
				<Select showSearch allowClear={true} placeholder="Select a model" onChange={(value) => setSelectedModel(value)}>
					{filteredModels?.map((model) => (
						<Select.Option value={model._id} key={model._id}>
							{model.name}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Variant"
				name={['vehicle', 'variant']}
				initialValue={vehicle.variant}
				rules={InputRules.required('Select a trim/variant!')}
			>
				<Select showSearch allowClear={true} placeholder="Select a generation">
					{generations?.map((generation) => (
						<Select.Option value={generation._id} key={generation._id}>
							{generation.name}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Year"
				name={['vehicle', 'year']}
				initialValue={vehicle.year}
				rules={InputRules.required('Please select year!')}
			>
				<Select showSearch allowClear={true} placeholder="Select a year">
					{years?.map((year) => (
						<Select.Option value={year} key={year}>
							{year}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Transmission"
				name={['vehicle', 'transmission']}
				rules={InputRules.required('Please select Transmission!')}
				initialValue={vehicle.transmission}
			>
				<Select showSearch allowClear={true} placeholder="Select a transmission">
					<Select.Option value="automatic">Automatic</Select.Option>
					<Select.Option value="manual">Manual</Select.Option>
				</Select>
			</Form.Item>
			<Form.Item
				label="Interior Color"
				name={['vehicle', 'interiorColor']}
				initialValue={vehicle.interiorColor}
				rules={InputRules.required('Please select interior color!')}
			>
				<Select showSearch allowClear={true} placeholder="Select a interior color">
					{utils?.colors?.map((color) => (
						<Select.Option value={color.name} key={color._id}>
							{color.name}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Exterior Color"
				name={['vehicle', 'exteriorColor']}
				initialValue={vehicle.exteriorColor}
				rules={InputRules.required('Please select exterior color!')}
			>
				<Select showSearch allowClear={true} placeholder="Select a exterior color">
					{utils?.colors?.map((color) => (
						<Select.Option value={color.name} key={color._id}>
							{color.name}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Reg. City"
				name={['vehicle', 'registrationCity']}
				rules={InputRules.required('Please select reg. city!')}
				initialValue={vehicle.registrationCity}
			>
				<Select showSearch allowClear={true} placeholder="Select a reg. city">
					{regCities?.map((city) => (
						<Select.Option value={city} key={city}>
							{city}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Ad City"
				name={['vehicle', 'location', 'city']}
				rules={InputRules.required('Please select ad city!')}
				initialValue={vehicle.location.city}
			>
				<Select showSearch allowClear={true} placeholder="Select a ad city">
					{regCities?.map((city) => (
						<Select.Option value={city} key={city}>
							{city}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Body Type"
				name={['vehicle', 'bodyType']}
				rules={InputRules.required('Please select body type!')}
				initialValue={vehicle.bodyType}
			>
				<Select showSearch allowClear={true} placeholder="Select a body type">
					{bodyTypes?.map((bodyType) => (
						<Select.Option value={bodyType} key={bodyType}>
							{bodyType}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Description"
				name={['vehicle', 'description']}
				rules={InputRules.required('Please select description!')}
				initialValue={vehicle.description}
			>
				<Input.TextArea rows={4}></Input.TextArea>
			</Form.Item>
			<Form.Item
				label="Custom Features"
				name={['vehicle', 'customFeatures']}
				rules={InputRules.required('Please select custome features!')}
				initialvalues={vehicle.customFeatures}
			>
				<Select showSearch allowClear={true} placeholder="Select a custom features" mode="multiple">
					{features?.map((feature) => (
						<Select.Option value={feature} key={feature}>
							{feature}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Price"
				name={['vehicle', 'price']}
				initialValue={vehicle.price}
				rules={InputRules.required('Input price!')}
			>
				<InputNumber />
			</Form.Item>
			<Form.Item
				label="Mileage"
				name={['vehicle', 'mileage']}
				initialValue={vehicle.mileage}
				rules={InputRules.required('Input mileage!')}
			>
				<InputNumber />
			</Form.Item>
			<Form.Item
				label="Fuel Average"
				name={['vehicle', 'average']}
				initialValue={vehicle.average}
				rules={InputRules.required('Input fuel average!')}
			>
				<InputNumber />
			</Form.Item>
			<Form.Item
				label="Interior Condition"
				name={['vehicle', 'condition', 'interior']}
				rules={InputRules.required('Please select condition!')}
				initialValue={vehicle.condition.interior}
			>
				<Slider tipFormatter={(value) => `${value}%`} />
			</Form.Item>
			<Form.Item
				label="Exterior Condition"
				name={['vehicle', 'condition', 'exterior']}
				rules={InputRules.required('Please select condition!')}
				initialValue={vehicle.condition.exterior}
			>
				<Slider tipFormatter={(value) => `${value}%`} />
			</Form.Item>
			<Form.Item
				label="Engine Condition"
				name={['vehicle', 'condition', 'engine']}
				rules={InputRules.required('Please select condition!')}
				initialValue={vehicle.condition.engine}
			>
				<Slider tipFormatter={(value) => `${value}%`} />
			</Form.Item>
			<Form.Item
				label="Transmission Condition"
				name={['vehicle', 'condition', 'transmission']}
				rules={InputRules.required('Please select condition!')}
				initialValue={vehicle.condition.transmission}
			>
				<Slider tipFormatter={(value) => `${value}%`} />
			</Form.Item>
			<Form.Item
				label="Tyres Condition"
				name={['vehicle', 'condition', 'tyres']}
				rules={InputRules.required('Please select condition!')}
				initialValue={vehicle.condition.tyres}
			>
				<Slider tipFormatter={(value) => `${value}%`} />
			</Form.Item>
			<Form.Item
				label="Suspension Condition"
				name={['vehicle', 'condition', 'suspension']}
				rules={InputRules.required('Please select condition!')}
				initialValue={vehicle.condition.suspension}
			>
				<Slider tipFormatter={(value) => `${value}%`} />
			</Form.Item>
			<Form.Item label="Upload Images" name="images" initialvalues={vehicle.images}>
				<Upload
					multiple
					accept=".jpg,.png,.jpeg"
					listType="picture-card"
					onChange={handleChange}
					fileList={filelist}
					beforeUpload={() => false}
				>
					{uploadButton}
				</Upload>
			</Form.Item>
			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit">
					Update Vehicle
				</Button>
			</Form.Item>
		</Form>
	);
};

const mapStateToProps = (store) => ({
	makes: store.vehicleMake.makes,
	models: store.vehicleModel.models,
	generations: store.vehicleGeneration.generations,
	utils: store.vehicleUtil.utils,
});

const mapDispatchToProps = (dispatch) => ({
	fetchMakes: () => dispatch(Actions.fetchMakes()),
	fetchModels: () => dispatch(Actions.fetchModels()),
	fetchGenerations: () => dispatch(Actions.fetchGenerations()),
	fetchVehicleUtils: () => dispatch(Actions.fetchVehicleUtils()),
	updateVehicleAd: (id, body) => dispatch(Actions.updateVehicleAd(id, body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VehicleEditForm);
